<template>
    <div>
        <div class="notice">
            {{ $t('You need to deposit to claim this bonus. Do not worry, you will be able to do this' +
                ' later') }}
        </div>
        <div class="decision-card">
            <div
                @click="onDeposit"
                class="decision-card__wrapper"
            >
                <div class="decision-card__content">
                    <div class="decision-card__details">
                        <div class="decision-card__title">
                            {{ $t('choose bonus now and deposit') | capitalize }}
                        </div>
                        <div class="decision-card__text">
                            {{ $t('You will get a chance to choose your first deposit bonus. '
                                + 'We have some extras to do this') }}
                        </div>
                        <div class="decision-card__action">
                            <span class="subtle-link">
                                <span class="subtle-link__text">
                                    {{ $t('deposit') | capitalize }}
                                </span>
                                <i class="icon subtle-link__icon icon-arrow_right"/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="decision-card">
            <div
                @click="onExplore"
                class="decision-card__wrapper"
            >
                <div class="decision-card__title">
                    {{ $t('I\'ll do that later') }}
                </div>
                <div class="decision-card__text">
                    {{ $t('Feel free to make your ticket and explore the site. You will be required to fill' +
                        ' in all the missing information and deposit it with your first bet ') }}
                </div>
                <div class="decision-card__action">
                    <span class="subtle-link">
                        <span class="subtle-link__text">
                            {{ $t('explore') | capitalize }}
                        </span>
                        <i class="icon subtle-link__icon icon-arrow_right"/>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import { routeNames } from '@app/router';

    export default {
        name: 'WelcomeBonusIntroModal',
        methods: {
            ...mapActions('ui/modal', [
                'closeAllModals',
            ]),
            onDeposit() {
                this.$router.push({ name: routeNames.deposit });
                this.closeAllModals();
            },
            onExplore() {
                this.$router.push({ name: routeNames.landing });
                this.closeAllModals();
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modals/modals/welcomeBonus/WelcomeBonusIntroModal.vue